import { useState } from 'react';
import ClubsResortListing from '../components/clubsresort/ClubsResortListing';
import ClubsResortDetails from '../components/clubsresort/ClubsResortDetails';
import AddClubForm from '../components/clubsresort/AddClubForm';
import ClubAddedSuccessModal from '../components/clubsresort/ClubAddedSuccessModal';
import { useGlobalStates } from '../utlis/ClubsContext';
import EditClubDetailsModal from "../components/clubsresort/EditClubDetailsModal";
import { callApi } from '../services/ApiServices';
import CommonLoader from '../components/common/CommonLoader';

const ClubsResort = () => {
  const [view, setView] = useState('listing'); // 'listing', 'details', 'add'
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [savedClubData, setSavedClubData] = useState(null);
  const [formKey, setFormKey] = useState(0);
  const[loading,setLoading] = useState(false)
 const{ selectedClub,setSelectedClub, handleSelectedClubDetail} = useGlobalStates()


  const handleClubSelect = async(club) => {
    setView("details");
    try{
      setLoading(true)
      const response = await handleSelectedClubDetail(club)
      if(response.status === 200){
        setSelectedClub(response)
      }
    }catch(error){
      console.log("error while fetching club details", error)
    }finally{
      setLoading(false)
    }
  };

  const handleAddClub = () => {
    setView("add");
  };

  const handleBackToListing = () => {
    setView("listing");
    setSelectedClub(null);
  };

  const handleSaveClub = (clubData) => {
    console.log("Saving club:", clubData);
    // Handle save logic here
    setSavedClubData(clubData);
    setShowSuccessModal(true);
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    setView("listing");
    setSavedClubData(null);
  };

  const handleAddAnotherClub = () => {
    setShowSuccessModal(false);
    setSavedClubData(null);
    // Stay on add view, form will reset
    setView('add');
    setFormKey((prevKey)=> prevKey +1)
  };

  const handleViewClub = () => {
    setShowSuccessModal(false);
    // In a real app, you would set the newly created club as selected
    // For now, just navigate to listing
    setView("listing");
    setSavedClubData(null);
  };

  // Show Add Club form
  if (view === "add") {
    return (
      <>
        <AddClubForm  key={formKey} onClose={handleBackToListing} onSave={handleSaveClub} />
        {showSuccessModal && (
          <ClubAddedSuccessModal
            onClose={handleCloseSuccessModal}
            onAddAnother={handleAddAnotherClub}
            onViewClub={handleViewClub}
          />
        )}
      </>
    );
  }

  if(loading === true){
    return <CommonLoader fullScreen={true} />
  }

  // Show details view if a club is selected
  if (view === "details" && selectedClub) {
    return (
      <div>
        {/* Back Button */}
        <button
          onClick={handleBackToListing}
          className="flex items-center gap-2 text-base font-medium text-primary hover:text-hover transition-colors mb-6"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 5L7.5 10L12.5 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Back to Clubs
        </button>
        <ClubsResortDetails club={selectedClub} />
      
      </div>
    );
  }

  // Show listing view by default
  return (
    <>
      <ClubsResortListing
        onClubSelect={handleClubSelect}
        onAddClub={handleAddClub}
      />
      {showSuccessModal && (
        <ClubAddedSuccessModal
          onClose={handleCloseSuccessModal}
          onAddAnother={handleAddAnotherClub}
          onViewClub={handleViewClub}
        />
      )}
    </>
  );
};

export default ClubsResort;
